import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`masked-line block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const GoldLine = ({ className = "", delay = 0 }) => (
  <motion.span
    aria-hidden="true"
    initial={{ scaleX: 0 }}
    whileInView={{ scaleX: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 1.2, delay, ease: EASE }}
    className={`block h-px origin-left bg-gold ${className}`}
  />
);

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <span
    className={`eyebrow inline-flex max-w-full items-center gap-3 text-xs font-medium uppercase tracking-[0.25em] ${
      light ? "text-gold-pale" : "text-gold"
    } ${className}`}
  >
    <span className="inline-block h-px w-8 shrink-0 bg-gold" aria-hidden="true" />
    {children}
  </span>
);
